import {Component, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '@app/services/navigation.service';
import {UserService} from "@app/services/user.service";
import {environment} from "@env/environment";


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  @Input() loginButton?: boolean = false;
  isLoading: boolean = false;
  public imgSrc: string = environment.imgBaseline;

  public loginInput = '';

  constructor(private router: Router, private _userService: UserService, private _navService: NavigationService) { }

  async ngOnInit() {
  }

  async login() {
    this.isLoading = true;
    await this._userService.Login();
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData) {
      this.isLoading = false;
      await this._navService.navigate('home')
    }
    this.isLoading = false;
  }

}
